import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { selectField } from '@/features/bulk-edit/selectors'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { setActive, setClosed, setInactive, setOpen } from '../slice'
import ActionSelect from './inputs/ActionSelect'

import DropDown from './inputs/DropDown'
import MultiSelect from './inputs/MultiSelect'
import MultiText from './inputs/MultiText'
import TextArea from './inputs/TextArea'
import TextField from './inputs/TextField'
import StatusIndicator from './StatusIndicator'

export default function BulkEditOption(props: TODO) {
  const { name: _name } = props

  const { field, isOpen, isActive } = useAppSelector(selectField(_name))
  const { name, label, inputType } = field

  const theme = useTheme()
  const dispatch = useAppDispatch()

  function handleOpenChange() {
    isOpen ? dispatch(setClosed(name)) : dispatch(setOpen(name))
  }

  function handleActiveChange() {
    isActive ? dispatch(setInactive(name)) : dispatch(setActive(name))
  }

  function OptionInput() {
    switch (inputType) {
      case 'textarea':
        return <TextArea key={name} name={name} />

      case 'textfield':
        return <TextField key={name} name={name} />

      case 'dropdown':
        return <DropDown key={name} name={name} />

      case 'multiselect':
        return <MultiSelect key={name} name={name} />

      case 'multitext':
        return <MultiText key={name} fieldName={name} />

      default:
        console.error(Error(`Input Type: ${inputType} isn't defined`))
        return (
          <Typography
            key={name}
          >{`Input Type: ${inputType} isn't defined`}</Typography>
        )
    }
  }

  return (
    <Accordion onChange={handleOpenChange} expanded={isOpen}>
      <AccordionSummary
        sx={{ background: isActive ? theme.palette.primary.light : undefined }}
      >
        <Stack
          direction="row"
          alignItems="baseline"
          justifyContent="space-between"
          minWidth="100%"
        >
          <Typography>{label}</Typography>
          <StatusIndicator
            name={_name}
            label={label}
            onClick={handleActiveChange}
            isActive={isActive || false}
          />
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack paddingTop={1} paddingBottom={1} gap={2}>
          <ActionSelect fieldName={_name} />
          <Box>{OptionInput()}</Box>
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
